import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useState } from 'react';
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';
import { GoX } from 'react-icons/go';
import Img from 'gatsby-image';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import useMousetrap from 'react-hook-mousetrap';
import * as S from './styles';

// TODO add preloading or loading animation
import { jsx as ___EmotionJSX } from "@emotion/react";
const Lightbox = props => {
  const {
    images,
    thumbnails,
    thumbnailStyle
  } = props;
  const {
    0: lightboxOpen,
    1: setLightboxOpen
  } = useState(false);
  const {
    0: selectedImageIndex,
    1: setSelectedImageIndex
  } = useState(null);
  const onImageClick = index => {
    setLightboxOpen(true);
    setSelectedImageIndex(index);
  };
  const onClose = () => {
    setLightboxOpen(false);
    setSelectedImageIndex(null);
  };
  const onNext = e => {
    if (e) {
      e.stopPropagation();
    }
    let nextIndex = selectedImageIndex + 1;
    if (nextIndex === images.length) {
      nextIndex = 0;
    }
    setSelectedImageIndex(nextIndex);
  };
  const onPrev = e => {
    if (e) {
      e.stopPropagation();
    }
    let prevIndex = selectedImageIndex - 1;
    if (selectedImageIndex === 0) {
      prevIndex = images.length - 1;
    }
    setSelectedImageIndex(prevIndex);
  };
  useMousetrap('right', () => onNext());
  useMousetrap('left', () => onPrev());
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(S.Container, {
    thumbnailWidth: props.thumbnailWidth
  }, thumbnails.map((thumbnail, index) => {
    let hovered = false;
    thumbnail = thumbnail.file.localFile;
    return ___EmotionJSX("button", {
      style: _objectSpread({}, thumbnailStyle),
      "aria-label": "Bild \xF6ffnen",
      key: thumbnail.name,
      onClick: () => {
        onImageClick(index);
      }
    }, ___EmotionJSX(Img, {
      fluid: thumbnail.childImageSharp.fluid
    }));
  })), lightboxOpen && ___EmotionJSX(DialogOverlay, {
    onDismiss: onClose,
    overlayBgColor: props.overlayBgColor,
    css: S.dialogOverlay
  }, ___EmotionJSX(S.Counter, null, selectedImageIndex + 1, " / ", images.length), ___EmotionJSX(S.Button, {
    "aria-label": "Schlie\xDFen",
    className: "int-btn-close",
    onClick: e => {
      onClose(e);
    }
  }, ___EmotionJSX(GoX, null)), ___EmotionJSX(S.Button, {
    "aria-label": "Vorheriges Bild",
    className: "int-btn-prev",
    onClick: e => {
      onPrev(e);
    }
  }, ___EmotionJSX(FaArrowLeft, null)), ___EmotionJSX(DialogContent, {
    css: S.dialogContent,
    ar: images[selectedImageIndex].file.localFile.childImageSharp.fluid.aspectRatio
  }, ___EmotionJSX("img", {
    src: images[selectedImageIndex].file.localFile.childImageSharp.fluid.src,
    alt: images[selectedImageIndex].name
  })), ___EmotionJSX(S.Button, {
    "aria-label": "N\xE4chstes Bild",
    className: "int-btn-next",
    onClick: e => {
      onNext(e);
    }
  }, ___EmotionJSX(FaArrowRight, null))));
};
Lightbox.defaultProps = {
  thumbnailWidth: '250px',
  overlayBgColor: 'rgba(255,255,255,0.95)'
};
export default Lightbox;